module.exports = __webpack_public_path__ + "static/01-6dc9c53a8401c593cc480d4a047be738.png";